import classnames from 'clsx'
import { arrayOf, oneOfType, shape, string } from 'prop-types'

import Badge from 'views/components/atoms/Badge'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import IconInline from 'views/components/atoms/IconInline'
import SubmenuCard from 'views/components/organisms/HeaderNew/SubmenuCard'

const renderListItem = (
  { href, id, text, openInNewTab, discountBadge },
  index
) => (
  <li
    className={classnames({
      'u-padding--top@small-tiny': index,
      'u-padding-small--top@medium': index,
    })}
    key={id}
  >
    <a
      className="a-link--ui u-color--blue"
      href={href}
      rel="noreferrer"
      target={openInNewTab ? '_blank' : '_self'}
    >
      <div className="l-flex@small-tiny l-flex--distribute-space@small-tiny">
        <div className="l-flex">
          {discountBadge && (
            <Badge
              value="%"
              color="red"
              size="x-small"
              className="u-margin-small--right"
            />
          )}
          {/* translation "header.link.myTherapy" in shop config contains HTML markup */}
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <IconInline
          className="u-visuallyhidden@medium l-flex__fixed"
          component={IconCaretRight}
        />
      </div>
    </a>
  </li>
)

const MenuCardItem = ({ section, cardClasses, boxClasses }) => (
  <SubmenuCard
    title={section.title}
    cardClasses={cardClasses}
    boxClasses={boxClasses}
  >
    <ul className="a-list-reset">{section.links.map(renderListItem)}</ul>
  </SubmenuCard>
)

MenuCardItem.propTypes = {
  section: shape({ title: string, links: arrayOf(shape({})) }).isRequired,
  cardClasses: oneOfType([shape({}), string]),
  boxClasses: string,
}

MenuCardItem.defaultProps = {}

export default MenuCardItem
